<template>
  <div class="orderAfterSale">
    <div class="top">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="售后中" name="first">
          <div class="sub-main" v-loading="loading">
            <AftersaleList @handleCurrentChange="handleCurrentChange" v-if="listShow" :afterSaleList="afterSaleList" :total="total" :page="page"></AftersaleList>
          </div>
        </el-tab-pane>
        <el-tab-pane label="已完成" name="second">
          <div class="sub-main" v-loading="loading">
            <AftersaleList @handleCurrentChange="handleCurrentChange" v-if="listShow" :afterSaleList="afterSaleList" :total="total" :page="page"></AftersaleList>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="search">
        <div>订单筛选：</div>
        <el-select v-model="screenOrderValue" @change="screenOrder" placeholder="请选择" style="margin-right: 15px;">
          <el-option label="零售订单" :value="0"></el-option>
          <el-option label="大宗订单" :value="1"></el-option>
        </el-select>
        <el-input placeholder="商品名称/订单号" v-model="search" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="searchOrder"></el-button>
        </el-input>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../../api'
import {listSearchMixin} from '../../../config/mixin'
import AftersaleList from '../../../components/base/aftersaleList'
export default {
  name: 'orderAfterSale',
  mixins: [listSearchMixin],
  components: {
    AftersaleList
  },
  data () {
    return {
      afterSaleList: [],
      activeName: 'first',
      search: '',
      page: 1,
      total: 0,
      state: 1,
      listShow: false,
      loading: false,
      screenOrderValue:null
    }
  },
  mounted () {
    let platform = localStorage.getItem('platform');
    if(platform == 'b2b'){
      this.screenOrderValue = 1;
    }else{
      this.screenOrderValue = 0;
    }
    this.getAfterSaleList()
  },
  methods: {
    //筛选订单
    screenOrder(val){
      this.getAfterSaleList(val);
    },
    // 获取售后列表
    getAfterSaleList (value) {
      // const rLoading = this.openLoading()
      let self = this
      self.loading = true
      let params = {
        url: api.getAfterSaleList + `?category=${value != undefined? value : this.screenOrderValue}&state=${this.state}&page=${this.page}&pageSize=5&search=${this.search}`,
        method: 'GET'
      }
      self.sendReq(params, (res) => {
        if (res.code === '200') {
          self.afterSaleList = res.data.list
          self.total = res.data.total
          self.listShow = true
          // rLoading.close()
          self.loading = false
        } else {
          self.$message({
              message: res.message,
              type: 'warning'
          })
        }
      })
    },
    // 搜索订单
    searchOrder () {
      this.page = 1
      this.getAfterSaleList()
    },
    // 切换列表
    handleClick (event) {
      this.state = Number(event.index) + 1
      this.page = 1
      this.getAfterSaleList()
    },
    // 分页器跳转
    handleCurrentChange (val) {
      this.page = val
      this.getAfterSaleList()
    }
  }
}
</script>
<style lang="scss" scoped>
.orderAfterSale{
  width: 100%;
  .top{
    width: 100%;
    font-size: 14px;
    box-sizing: border-box;
    position: relative;
    >>>.el-tabs{
      .el-tabs__header{
        border: 1px solid #E5E5E5;
        margin-bottom: 30px;
        height: 56px;
      }
      .el-tabs__nav{
        margin-left: 20px;
        height: 56px;
      }
      .el-tabs__item{
        height: 56px;
        line-height: 56px;
      }
      .el-tabs__nav-wrap::after{
        height: 0;
      }
    }
    >>>.search{
      font-size: 12px;
      margin-right: 20px;
      display: flex;
      position: absolute;
      height: 56px;
      display: flex;
      align-items: center;
      top: 0;
      right: 0;
      .el-input{
        flex: 3;
        border-radius: 0;
        .el-input__inner{
          border-radius: 0;
        }
        .el-input-group__append{
          border-radius: 0;
          border-left: 0;
          .el-button{
            border-left: 0;
          }
        }
      }
      .el-select{
        flex: 1;
        border-radius: 0;
        height: 40px;
      }
    }
  }
}
.sub-main{
  min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/orderAfterSale/orderAfterSale.vue